// extracted by mini-css-extract-plugin
export default {"container":"GoogleRating_container__TlQOp","buttonSeeAll":"GoogleRating_buttonSeeAll__Pb109","rating":"GoogleRating_rating__v7uWG"};